import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';
import { lightColours } from '../../styles/colours';

// Helper function to format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

const QuickComparison = ({ comparisonData, onReadMoreClick }) => {
  const { differences, betterOption } = comparisonData;

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Paper elevation={0} sx={{ 
      p: 4, 
      backgroundColor: lightColours.lightBlue,
      textAlign: 'center',
      border: '1px solid #e0e0e0',
      mb: 4
    }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ 
        fontWeight: 'bold',
        color: lightColours.darkBlue,
        mb: 3
      }}>
        Quick Comparison Result
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        {betterOption === 'equal' ? (
          'Both salary options provide equal total compensation value'
        ) : (
          <>
            {betterOption === 'B' ? 'New Salary' : 'Current Salary'} provides{' '}
            <strong>{formatCurrency(Math.abs(differences.totalCompensation))} more</strong> in total compensation value
            {Math.abs(differences.totalCompensation) >= 1000 && (
              <span> (that's <strong>{formatCurrency(Math.abs(differences.totalCompensation) / 12)} more per month</strong>)</span>
            )}
          </>
        )}
      </Typography>
      
      {Math.abs(differences.takeHome) !== Math.abs(differences.totalCompensation) && (
        <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic', color: 'text.secondary' }}>
          Note: While take-home pay differs by {formatCurrency(Math.abs(differences.takeHome))}, 
          the total value including pension benefits differs by {formatCurrency(Math.abs(differences.totalCompensation))}.
        </Typography>
      )}
      
      <Box sx={{ mt: 3 }}>
        <Link 
          component="button"
          variant="body2" 
          onClick={() => scrollToSection('detailed-results')}
          sx={{ 
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Read more on how this is calculated below ↓
        </Link>
      </Box>
    </Paper>
  );
};

export default QuickComparison;